import { render, staticRenderFns } from "./HelpListCadastral.vue?vue&type=template&id=bd05ca5e&"
import script from "./HelpListCadastral.vue?vue&type=script&lang=js&"
export * from "./HelpListCadastral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports